import { toJS } from 'mobx'
import { types, flow } from 'mobx-state-tree'
import _ from 'lodash'

import { API } from '../api'

const { model, optional } = types

const UserSettings = model({
  newChangesPageViewed: false,
  glidePath: false,
  riskRulerState: 'none',
  // When true, the all-excluded SSI advice step is skipped. Reset whenever the
  // user re-includes SSI (see SocialSecurity.saveSSBenefits).
  hideSsiAdviceStep: false,
  /* When true, the statement-upload intro screen is skipped and the file picker opens directly.
     Off until the backend stores this key; a PUT carrying it today would just drop it.
     TODO(GC-17972): restore when user-settings can store the choice.
  hideUploadStatementIntro: false, */
})

const UserSettingsStore = model({
  userSettings: optional(UserSettings, {}),
}).actions(self => ({
  getUserSettings: flow(function* () {
    const userSettings = yield API.get('user-settings')
    self.userSettings = userSettings.data || {}
  }),

  syncUserSettings: _.debounce(function () {
    self.updateUserSettings()
  }, 500),

  updateUserSettings() {
    API.put('user-settings', toJS(self.userSettings))
  },

  handleNewChangesPageView() {
    self.userSettings.newChangesPageViewed = true
    self.updateUserSettings()
  },

  // Records/clears the "don't show me the SSI advice step again" preference.
  setHideSsiAdviceStep(value) {
    if (self.userSettings.hideSsiAdviceStep === value) return
    self.userSettings.hideSsiAdviceStep = value
    self.updateUserSettings()
  },

  /* Records the "don't show me again" choice on the statement-upload intro screen.
     TODO(GC-17972): restore when user-settings can store the choice.
  setHideUploadStatementIntro(value) {
    if (self.userSettings.hideUploadStatementIntro === value) return
    self.userSettings.hideUploadStatementIntro = value
    self.updateUserSettings()
  }, */

  handleGlidePathChange() {
    self.userSettings.glidePath = !self.userSettings.glidePath
    self.syncUserSettings()
  },

  handleRiskRulerForward() {
    const { riskRulerStates } = self.config.template

    // Find the index of the current state in riskRulerStates
    const currentIndex = riskRulerStates.findIndex(
      state => state === self.userSettings.riskRulerState
    )
    const length = riskRulerStates.length

    // Increment by 1
    const newIndex = currentIndex + 1

    // Grab the new state by getting the value of the array at the new index or rolling over to the beginning at index 0
    if (!length) {
      self.userSettings.riskRulerState = 'none'
    } else if (newIndex >= length) {
      self.userSettings.riskRulerState = riskRulerStates[0]
    } else {
      self.userSettings.riskRulerState = riskRulerStates[newIndex]
    }

    self.syncUserSettings()
  },

  handleRiskRulerBack() {
    const { riskRulerStates } = self.config.template

    // Find the index of the current state in riskRulerStates
    const currentIndex = riskRulerStates.findIndex(
      state => state === self.userSettings.riskRulerState
    )
    const length = riskRulerStates.length

    // Decrement by 1
    const newIndex = currentIndex - 1

    // Grab the new state by getting the value of the array at the new index or rolling over to the end at index array length - 1
    if (!length) {
      self.userSettings.riskRulerState = 'none'
    } else if (newIndex < 0) {
      self.userSettings.riskRulerState = riskRulerStates[length - 1]
    } else {
      self.userSettings.riskRulerState = riskRulerStates[newIndex]
    }

    self.syncUserSettings()
  },
}))

export default UserSettingsStore
